import {
  SHORTFALL_TIER1_LIMIT_MWH,
  SHORTFALL_TIER1_RATE_PER_MWH,
  SHORTFALL_TIER2_RATE_PER_MWH
} from '../data/constants.js';

export function shortfallPenalty(shortfallMwh) {
  if (shortfallMwh <= 0) return 0;
  if (shortfallMwh <= SHORTFALL_TIER1_LIMIT_MWH) {
    return shortfallMwh * SHORTFALL_TIER1_RATE_PER_MWH;
  }
  const tier1Cost =
    SHORTFALL_TIER1_LIMIT_MWH * SHORTFALL_TIER1_RATE_PER_MWH;
  const tier2Mwh = shortfallMwh - SHORTFALL_TIER1_LIMIT_MWH;
  return tier1Cost + tier2Mwh * SHORTFALL_TIER2_RATE_PER_MWH;
}
